import { render } from "./ArchiveDeleteModal.vue?vue&type=template&id=0590495c&scoped=true"
import script from "./ArchiveDeleteModal.vue?vue&type=script&lang=js"
export * from "./ArchiveDeleteModal.vue?vue&type=script&lang=js"

import "./ArchiveDeleteModal.vue?vue&type=style&index=0&id=0590495c&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0590495c"]])

export default __exports__